import React from 'react';
import { useQuill, useQuillReadOnly } from '../QuillContext';
import EditorToolbar from '../controls/toolbar/EditorToolbar';
import type { Blot } from '../types';
import useLinkShortcut from '../useLinkShortcut';
import applyBlockFormat from './applyBlockFormat';

interface CodeEmbedEditorToolbarProps {
  blot: Blot;
}

const CodeEmbedEditorToolbar = ({ blot }: CodeEmbedEditorToolbarProps) => {
  const { quill, ancestorQuill } = useQuill();
  const readOnly = useQuillReadOnly();

  useLinkShortcut();

  return (
    quill &&
    ancestorQuill && (
      <EditorToolbar
        readOnly={readOnly}
        portalContainer={ancestorQuill.container}
        objectButtonOptions={{
          defaultLabel: 'Code block',
          applyFormat: (format) =>
            applyBlockFormat(quill, ancestorQuill, blot, format),
          queryFormat: (format) => ancestorQuill.scroll.query(format),
        }}
      />
    )
  );
};

export default CodeEmbedEditorToolbar;
